<template>
	<div class="container col-lg-6 px-4 py-5 mt-5">
		<div class="row justify-content-center pt-5 mt-5">
			<div class="col-12 col-md-8 col-lg-6 text-center">
				<div class="mb-5">
					<img src="@/assets/equivate_logo.svg" alt="Equivate logo">
				</div>

				<div v-if="error" class="alert alert-danger" role="alert">
					{{ error }}
					<div class="mt-3">
						<router-link to="/login" class="btn btn-primary">Back to Login</router-link>
					</div>
				</div>

				<div v-else>
					<div class="spinner-border text-primary" role="status">
						<span class="visually-hidden">Loading...</span>
					</div>
					<p class="mt-3 text-muted">Completing sign in...</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { authService, authMutations, sessionMonitor } from '@/auth'

export default {
	name: 'AuthCallbackView',

	data() {
		return {
			error: null
		}
	},

	async mounted() {
		// Check for error from OAuth provider
		if (this.$route.query.error) {
			this.error = this.$route.query.error
			return
		}

		try {
			const status = await authService.getAuthStatus()

			if (!status) {
				this.$router.push('/login')
				return
			}

			authMutations.setUser(status)

			if (status.activeTenant) {
				authMutations.setActiveTenant(status.activeTenant)
				authMutations.setPermissions(status.permissions)
				sessionMonitor.start()
				this.$router.push(this.$route.query.redirect || '/')
			} else if (status.requiresTenantSelection) {
				this.$router.push('/select-tenant')
			} else {
				this.$router.push('/')
			}
		} catch (e) {
			this.error = 'Authentication failed. Please try again.'
		}
	}
}
</script>

<style scoped>
img {
	width: 152px;
	height: 37px;
}
</style>
